module.exports = __webpack_public_path__ + "img/Alfin-Banco.5616d385.svg";